import { render, staticRenderFns } from "./RiderScoresTable.vue?vue&type=template&id=577e4966&"
import script from "./RiderScoresTable.vue?vue&type=script&lang=js&"
export * from "./RiderScoresTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports